// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AssumeClientMenu_XwDr02iBLsEYKa8smUSY svg{border-color:rgba(0,0,0,0) !important}`, "",{"version":3,"sources":["webpack://./src/components/AssumeClientMenu/AssumeClientMenu.module.scss"],"names":[],"mappings":"AACE,2CACE,qCAAA","sourcesContent":[".AssumeClientMenu {\n  svg {\n    border-color: transparent !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"AssumeClientMenu": `AssumeClientMenu_XwDr02iBLsEYKa8smUSY`
};
export default ___CSS_LOADER_EXPORT___;
